/** Shopify CDN: Minification failed

Line 17:8 Transforming let to the configured target environment ("es5") is not supported yet

**/
(()=>{
        function e(t) {
            return e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e
                }
                : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                }
                ,
                e(t)
        }
        let gsLastUrl = window.location.href;
        if (!(window.location.href.indexOf("/products/") > 0)) {

            setInterval(function() {

                try {
                    if (gsLastUrl.length > 5 && window.location.href !== gsLastUrl) {
                        var url = window.location.href;
                        if (url.includes("/collections") || url.includes("/search")) {
                            gsLastUrl = url;
                            window.location.reload();
                        }
                    }


                } catch (err) {}

            }, 1000);

        }
        function t(e, t) {
            return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                var i = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != i) {
                    var r, n, o, a, l = [], c = !0, d = !1;
                    try {
                        if (o = (i = i.call(e)).next,
                        0 === t) {
                            if (Object(i) !== i)
                                return;
                            c = !1
                        } else
                            for (; !(c = (r = o.call(i)).done) && (l.push(r.value),
                            l.length !== t); c = !0)
                                ;
                    } catch (e) {
                        d = !0,
                            n = e
                    } finally {
                        try {
                            if (!c && null != i.return && (a = i.return(),
                            Object(a) !== a))
                                return
                        } finally {
                            if (d)
                                throw n
                        }
                    }
                    return l
                }
            }(e, t) || r(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function i(e) {
            return function(e) {
                if (Array.isArray(e))
                    return n(e)
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                    return Array.from(e)
            }(e) || r(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }
        function r(e, t) {
            if (e) {
                if ("string" == typeof e)
                    return n(e, t);
                var i = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === i && e.constructor && (i = e.constructor.name),
                    "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? n(e, t) : void 0
            }
        }
        function n(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var i = 0, r = new Array(t); i < t; i++)
                r[i] = e[i];
            return r
        }
        function o(e, t) {
            var i = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t && (r = r.filter((function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable
                    }
                ))),
                    i.push.apply(i, r)
            }
            return i
        }
        function a(e) {
            for (var t = 1; t < arguments.length; t++) {
                var i = null != arguments[t] ? arguments[t] : {};
                t % 2 ? o(Object(i), !0).forEach((function(t) {
                        l(e, t, i[t])
                    }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : o(Object(i)).forEach((function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t))
                    }
                ))
            }
            return e
        }
        function l(e, t, i) {
            return (t = d(t))in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i,
                e
        }
        function c(e, t) {
            for (var i = 0; i < t.length; i++) {
                var r = t[i];
                r.enumerable = r.enumerable || !1,
                    r.configurable = !0,
                "value"in r && (r.writable = !0),
                    Object.defineProperty(e, d(r.key), r)
            }
        }
        function d(t) {
            var i = function(t, i) {
                if ("object" !== e(t) || null === t)
                    return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, i || "default");
                    if ("object" !== e(n))
                        return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === i ? String : Number)(t)
            }(t, "string");
            return "symbol" === e(i) ? i : String(i)
        }
        window.ScrollBeeLastHandledHREF = null;
        setInterval((function() {
                var e, t, i;
                (null === (e = window) || void 0 === e ? void 0 : e.ScrollBeeLastHandledHREF) != window.location.href && (null === (t = window) || void 0 === t || null === (i = t.ScrollBee) || void 0 === i || i.setupExecution())
            }
        ), 1500);
        window.ScrollBee = new (function() {
            function e() {
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e),

                    this.config = {
                        qsaPaginationPages: "a.Pagination__NavItem[href*=page]",
                        qsaHideElements: ".Pagination",
                        qsProductGrid: "#custom-pro-wrap",
                        qsaProducts: "#custom-pro-wrap > div.Grid__Cell",
                        pageParam: "page",
                        minimumLoadingTimeout: 500,
                        debug: !1,
                        forceProductContainer: !1,
                        disableLoading: !1
                    };
                var t = document.getElementById("__scrollBeeConfig");
                t && (this.config = a(a({}, this.config), JSON.parse(t.getAttribute("data-config")))),
                    this.addKeyframes(),
                    this.setupExecution()
            }
            var r, n, o;
            return r = e,
            (n = [{
                key: "setupExecution",
                value: function() {
                    this.clearCurrentObserver(),
                        window.ScrollBeeLastHandledHREF = window.location.href;
                    try {
                        if (this.isLoading = !1,
                            this.lastLoadedPage = null,
                            this.lastPaginationPage = this.getLastPaginationPage(),
                            this.lastProductElement = this.getLastProductElement(),
                            this.intersectionObserver = null,
                            this.getLoadMoreButton())
                            return void this.setupLoadMoreButton();
                        if (!1 === this.lastPaginationPage || !1 === this.lastProductElement)
                            return;
                        this.applyObserver(),
                            this.hideElements()
                    } catch (e) {}
                }
            }, {
                key: "addKeyframes",
                value: function() {
                    var e = document.createElement("style");
                    e.setAttribute("type", "text/css"),
                        e.innerHTML = "@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}",
                        document.getElementsByTagName("head")[0].appendChild(e)
                }
            }, {
                key: "getLastPaginationPage",
                value: function(e) {
                    var t = this
                        , r = [];
                    if ([this.config.qsaPaginationPages, "span.page > a[href*=page]", "ul.pagination > li > span > a[href*=page]", "ul.pagination > li > a[href*=page]", "ul.pagination-custom > li > a[href*=page]", "nav.pagination > ul > li > a[href*=page]", "nav.pagination__nav > a[href*=page]", 'div.pagination > div.row > div > ul > li > a[href*=page]:not([href=""])', "#pagination > .pagination-wrapper > div.links > a[href*=page]", "div.pagination > a.page-number[href*=page]", "div.Pagination__Nav > a[href*=page]", "a.pagination--item[href*=page]", "a.pagination-custom__page[href*=page]", "span.pagination__number > a[href*=page]", "li.pagination-arrow > a[href*=page]"].forEach((function(t) {
                            if (0 === r.length) {
                                var i = null != e ? e : document;
                                r = Array.from(i.querySelectorAll(t))
                            }
                        }
                    )),
                    0 === r.length)
                        return !1;
                    var n = r.map((function(e) {
                            var i = new URL(e);
                            return parseInt(i.searchParams.get(t.config.pageParam))
                        }
                    ));
                    return Math.max.apply(Math, i(n))
                }
            }, {
                key: "getProductsContainer",
                value: function() {
                    var e = null;
                    return ["ul.product-grid", this.config.qsProductGrid, "div.grid.grid--uniform", "#collection-products", ".grid-uniform", "div.new-grid.product-grid.collection-grid", "#main-collection-product-grid > #CollectionProductGrid > ul", "product-list > .product-list__inner", "div.grid.grid--view-items.grid-products", "#Collection > ul.grid.grid--uniform.grid--view-items", "#main-collection-product-grid", "div.grid.rwcols-2.rwcols-md-3.rwcols-lg-3.grid-products.grid--view-items", "product-list", "div.ProductListWrapper > div.ProductList", "ul.productgrid--items", "#CollectionLoop", "div.product-list", "#Collection > div.col-md-12 > div.product-grid"].forEach((function(t) {
                            e || (e = document.querySelector(t))
                        }
                    )),
                    this.config.forceProductContainer && (e = document.querySelector(this.config.qsProductGrid)),
                        e
                }
            }, {
                key: "getLastProductElement",
                value: function() {
                    if (!this.getProductsContainer())
                        return !1;
                    var e = []
                        , t = [this.config.qsaProducts, "div.grid.grid--uniform > div.grid__item", "#collection-products > div.product", ".grid__item .grid-uniform div.grid__item", "div.grid__item.grid-product", "div.grid div.grid__item div.grid-uniform.grid-link__container div.grid__item", "ul.grid.product-grid > li.grid__item", "div.new-grid.product-grid.collection-grid > div.grid-item.grid-product", "#CollectionProductGrid > ul.collection-list > li", "product-list > .product-list__inner > product-item", "div.grid.grid--view-items.grid-products > div.grid__item.small--one-half.medium-up--one-third.widescreen--one-third", "#Collection > ul > li.grid__item", "#main-collection-product-grid > div.product-index", "#main-collection-product-grid > div.collection-template__product-item", "#product-grid > li.grid-item", "product-list > product-card", "#product-grid > card-product", "div.ProductListWrapper > div.ProductList > div.Grid__Cell", "#product-grid > div.content-item", "ul.productgrid--items > li.productgrid--item", "#CollectionLoop > div.product-item", "div.product-list > div.product-block", "#Collection > div.col-md-12 > div.product-grid > div.grid__item"]
                        , i = this;
                    return t.forEach((function(t) {
                            0 === e.length && (i.config.qsaProducts = t,
                                e = Array.from(document.querySelectorAll(t)))
                        }
                    )),
                    0 !== e.length && e.slice(-1)[0]
                }
            }, {
                key: "hideElements",
                value: function() {
                    document.querySelector('div.Pagination.Text--subdued').style.visibility = 'hidden';
                }
            }
                , {
                    key: "handleNewHtml",
                    value: function(e) {
                        var t, r, n, o, a = this, l = (new DOMParser).parseFromString(e, "text/html"), c = [this.config.qsaProducts, "#product-grid > li"], d = [];
                        c.forEach((function(e) {
                                0 === d.length && (d = l.querySelectorAll(e))
                            }
                        )),
                            (t = this.getProductsContainer()).append.apply(t, i(d)),
                            ["div.collection-filters > div > div.active"].forEach((function(e) {
                                    var t;
                                    null === (t = document.querySelector(e)) || void 0 === t || t.click()
                                }
                            )),
                            this.lastPaginationPage = this.getLastPaginationPage(l),
                        window.hc_fetch_resources && window.hc_fetch_resources(),
                        window.globoswatch && window.globoswatch.init(),
                        window.uwl_script_run && window.uwl_script_run(),
                        window.window.uwl_script_run && window.uwl_script_run(),
                        window.uwl_script_collection_ajax && window.uwl_script_collection_ajax(),
                        null !== (r = window.theme) && void 0 !== r && r.initAnimateOnScroll && window.theme.initAnimateOnScroll(),
                        null !== (n = window.theme) && void 0 !== n && null !== (o = n.ProductBlockManager) && void 0 !== o && o.loadImages && window.theme.ProductBlockManager.loadImages(),
                        window.StampedFn && window.StampedFn.loadBadges(),
                            document.dispatchEvent(new CustomEvent("theme:rimg:watch")),
                            document.dispatchEvent(new CustomEvent("scrollbee:loaded")),
                            ["empire","slick"].forEach((function(e) {
                                    a.reloadScript(e)
                                }
                            )),
                            document.querySelectorAll('a[data-hover-image="true"]').forEach((function(e) {
                                    return e.setAttribute("data-hover-image", "loaded")
                                }
                            )),
                            this.removeClassesCallback(),
                            this.addClassesCallback(),
                            this.stopLoading(),
                            this.reapplyObserver(),
                            this.hideElements(),
                            this.addAttributesCallback(),
                            this.outerHTMLCallback()
                    }
                }, {
                    key: "reloadScript",
                    value: function(e) {
                        for (var t = document.querySelectorAll("script"), i = 0; i < t.length; i++) {
                            var r = t[i]
                                , n = r.getAttribute("src");
                            if (n && n.includes(e)) {
                                for (var o = document.createElement("script"), a = 0; a < r.attributes.length; a++) {
                                    var l = r.attributes[a];
                                    o.setAttribute(l.name, l.value)
                                }
                                o.src = n,
                                    r.parentNode.replaceChild(o, r)
                            }
                        }
                    }
                }, {
                    key: "fetchNewHTML",
                    value: function() {
                        var e;
                        if (!(this.isLoading || this.lastLoadedPage >= this.lastPaginationPage)) {
                            this.startLoading();
                            var t = new URL(window.location.href)
                                , i = (null !== (e = this.lastLoadedPage) && void 0 !== e ? e : 1) + 1;
                            t.searchParams.set(this.config.pageParam, String(i));
                            var r = this;
                            try {
                                var n;
                                fetch("https://scroll-bee.app-hive.dev/api/scroll", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({
                                        ulid: null === (n = this.config) || void 0 === n ? void 0 : n.ulid,
                                        url: null == t ? void 0 : t.href
                                    })
                                })
                            } catch (e) {}
                            setTimeout((function() {
                                    fetch(t.href).then((function(e) {
                                            return e.text()
                                        }
                                    )).then((function(e) {
                                            r.lastLoadedPage = i,
                                                r.handleNewHtml(e)
                                        }
                                    )).catch((function(e) {}
                                    ))
                                }
                            ), this.config.minimumLoadingTimeout)
                        }
                    }
                }, {
                    key: "applyObserver",
                    value: function() {
                        this.clearCurrentObserver();
                        var e = this;
                        this.intersectionObserver = new IntersectionObserver((function(t) {
                                t[0].isIntersecting && e.fetchNewHTML()
                            }
                        ),{
                            root: null
                        }),
                            this.intersectionObserver.observe(this.lastProductElement)
                    }
                }, {
                    key: "reapplyObserver",
                    value: function() {
                        this.clearCurrentObserver(),
                            this.intersectionObserver.observe(this.getLastProductElement())
                    }
                }, {
                    key: "clearCurrentObserver",
                    value: function() {
                        var e;
                        null === (e = this.intersectionObserver) || void 0 === e || e.disconnect()
                    }
                }, {
                    key: "startLoading",
                    value: function() {
                        this.isLoading = !0;
                        var e = document.getElementById("__scrollBeeLoadingElement");
                        this.config.disableLoading || e || this.createLoadingElement()
                    }
                }, {
                    key: "createLoadingElement",
                    value: function() {
                        var e, t = this.loadingIndicatorLocation();
                        t || (t = this.getLastProductElement().parentElement);
                        var i = document.createElement("div");
                        i.id = "__scrollBeeLoadingElement",
                            i.style.padding = "2rem",
                            i.style.borderRadius = "0.375rem",
                            i.style.justifyContent = "center",
                            i.style.alignItems = "center",
                            i.style.width = "100%",
                            i.style.display = "flex",
                            i.classList.add("flex");
                        var r = document.createElement("div");
                        r.style.color = "#6D727E",
                            r.style.marginRight = "2rem",
                            r.textContent = null !== (e = this.config.loadingText) && void 0 !== e ? e : "";
                        var n = document.createElement("img");  // Change "image" to "img"
                        n.style.marginLeft = "0";
                        n.src = "https://media.tenor.com/uuEPRFM5xdcAAAAi/loader.gif";  // Directly set src, not as a style
                        n.style.width = "160px";
                        n.style.height = "24px";
                        n.style.display = "inline-block",
                            n.style.boxSizing = "border-box",
                            i.appendChild(r),
                            i.appendChild(n),
                            t.appendChild(i)
                    }
                }, {
                    key: "stopLoading",
                    value: function() {
                        this.isLoading = !1;
                        var e = document.getElementById("__scrollBeeLoadingElement");
                        e && e.remove()
                    }
                }, {
                    key: "removeClassesCallback",
                    value: function() {
                        for (var e = function() {
                            var e = t(r[i], 2)
                                , n = e[0]
                                , o = e[1];
                            Array.from(document.querySelectorAll(o)).forEach((function(e) {
                                    e.classList.remove(n)
                                }
                            ))
                        }, i = 0, r = Object.entries({
                            "scroll-trigger": "li.grid__item.scroll-trigger.animate--slide-in.scroll-trigger--offscreen",
                            "grid-product__image-link--loading": "a.grid-product__image-link.grid-product__image-link--loading"
                        }); i < r.length; i++)
                            e()
                    }
                }, {
                    key: "addClassesCallback",
                    value: function() {
                        for (var e = function() {
                            var e = t(r[i], 2)
                                , n = e[0]
                                , o = e[1];
                            Array.from(document.querySelectorAll(n)).forEach((function(e) {
                                    o.forEach((function(t) {
                                            e.classList.add(t)
                                        }
                                    ))
                                }
                            ))
                        }, i = 0, r = Object.entries({
                            "image-element[data-aos=image-fade-in]": ["aos-init", "aos-animate"]
                        }); i < r.length; i++)
                            e()
                    }
                }, {
                    key: "addAttributesCallback",
                    value: function() {
                        for (var e = function() {
                            var e = t(r[i], 2)
                                , n = e[0]
                                , o = e[1];
                            Array.from(document.querySelectorAll(n)).forEach((function(e) {
                                    o.forEach((function(t) {
                                            e.setAttribute(t.attribute, t.value)
                                        }
                                    ))
                                }
                            ))
                        }, i = 0, r = Object.entries({}); i < r.length; i++)
                            e()
                    }
                }, {
                    key: "outerHTMLCallback",
                    value: function() {
                        ["img.motion-reduce"].forEach((function(e) {
                                Array.from(document.querySelectorAll(e)).forEach((function(e) {
                                        e.outerHTML = e.outerHTML
                                    }
                                ))
                            }
                        ))
                    }
                }, {
                    key: "loadingIndicatorLocation",
                    value: function() {
                        var e = null;
                        return ["#CollectionProductGrid > div.bg-scheme-background.text-scheme-text.section-x-padding"].forEach((function(t) {
                                e || (e = document.querySelector(t))
                            }
                        )),
                            e
                    }
                }, {
                    key: "getLoadMoreButton",
                    value: function() {
                        var e = null;
                        return ["#load-more-button[data-next='']", "div.infinitpaginOuter > .infinitpagin > a.loadMore", "button.js-btn-load-more"].forEach((function(t) {
                                e || (e = document.querySelector(t))
                            }
                        )),
                            e
                    }
                }, {
                    key: "setupLoadMoreButton",
                    value: function() {
                        this.applyLoadMoreButtonObserver()
                    }
                }, {
                    key: "applyLoadMoreButtonObserver",
                    value: function() {
                        this.clearCurrentObserver();
                        var e = this;
                        this.intersectionObserver = new IntersectionObserver((function(t) {
                                var i;
                                e.isLoading || t[0].isIntersecting && (e.isLoading = !0,
                                null === (i = e.getLoadMoreButton()) || void 0 === i || i.click(),
                                    setTimeout((function() {
                                            e.isLoading = !1,
                                                e.clearCurrentObserver(),
                                                e.setupLoadMoreButton()
                                        }
                                    ), 750))
                            }
                        ),{
                            root: null
                        });
                        var t = this.getLoadMoreButton();
                        t && this.intersectionObserver.observe(t)
                    }
                }]) && c(r.prototype, n),
            o && c(r, o),
                Object.defineProperty(r, "prototype", {
                    writable: !1
                }),
                e
        }())
    }
)();
